import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useAuth } from '../context/auth-context';
import { INFO_PSE } from '../constants/form/validations';
import Button from '../components/DynamicForm/Button';
import Select from '../components/DynamicForm/Select.jsx';
import ConsultGeneral from '../services/consult/consult-general';
import { useDialog } from '../context/dialog-context';
// import { useNavigate } from 'react-router-dom';
import ConstantesSolicitudService from '../services/shared/constantes-solicitud-service';
import CreditoService from '../services/credit/credito-service';
import { Cache } from 'aws-amplify';
import { DIALOG } from '../constants/dialog/dialog';
// import { MdClose } from 'react-icons/md';

import { useLocation } from 'react-router-dom';

import OpenCoopCrmService from '../services/verification/open-coop-service';
import { formatCurrency, formatDateHour } from '../utils/format.js';

import { useNavigate } from 'react-router-dom';
import moment from 'moment';



import FormInput from '../components/Input/FormInput';
import useInput from '../hooks/use-input';
const docType = {
  1: 'CedulaDeCiudadania',
  2: 'TarjetaDeIdentidad',
  3: 'CedulaDeExtranjeria'
};
const docTypeOpen = {
  'C': 1,
  'TI': 2,
  'E': 3
};
// const docTypeUserType = {
//   1: 'person',
//   2: 'person',
//   3: 'person'
// };

const LandingPayuaCreate = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [fetchedConsultBankList, setFetchedConsultBankList] = useState();
  
  const [fullName, setFullName] = useState(user?.given_name + ' ' + user?.family_name);
  const [documentNumber, setDocumentNumber] = useState(user['custom:document'] || '');
  const [phoneNumber, setPhoneNumber] = useState(user?.phone_number.replace(/^(\+57)/, '') || '');
  const [getCreditId, setGetCreditId] = useState();
  const [getAddress, setGetAddress] = useState();
  const [getIdentityType, setGetIdentityType] = useState(1);
  const [getError, setGetError] = useState(false);
  const [getErrorfailed, setGetErrorfailed] = useState(false);
  const [getErrorfailedLimit, setGetErrorfailedLimit] = useState(false);
  let newTransactionSet = false;
  
  const dialog = useDialog();
  
  const location = useLocation();
  const ticketId = location.state?.ticketId ? location.state?.ticketId : sessionStorage.getItem('ticketId');
  
  
  const [formConstants, setFormConstants] = useState(
    Cache.getItem('form-constants')
  );
  const [fetchedLastCredit, setFetchedLastCredit] = useState(false);
  
  const [transactionValue, setTransactionValue] = useState(location.state?.transactionValue ? location.state?.transactionValue.replace(/[\s$,.]/g, ''): sessionStorage.getItem('transactionValue').replace(/[\s$,.]/g, ''));

  const {
      register,
      // handleSubmit,
      getValues,
      watch,
      control,
      reset,
      // setValue,
      formState: { errors },
    } = useForm({
      mode: 'all',
      defaultValues: {
        name: user ? user.given_name + ' ' + user.family_name : undefined,
        phone: user?.phone_number.replace(/^(\+57)/, ''),
        email: user?.email,
        term: 6,
      },
    });

    const { InputProps } = useInput({
      errors,
      getValues,
      register,
      control,
      validations: INFO_PSE,
    });

    const watchCreditId = getCreditId;
    const watchFinancialInstitutionCode = watch('financialInstitutionCode');              
    const watchTransactionValue = Number(transactionValue);              
    const watchTicketId = Number(ticketId);              
    const watchTicketIdPse = Number(ticketId + Math.floor(100000 + Math.random() * 900000));              
    const watchReferenceNumber1 = watch('referenceNumber1');              
    const watchReferenceNumber2 = watch('referenceNumber2') + '-' + Number(ticketId);              
    const watchReferenceNumber3 = watch('referenceNumber3');              
    const watchPaymentDescription = 'Pago PSE - #' + documentNumber + '-' + Number(ticketId); 

    const watchIdentificationType = Number(getIdentityType) === 0 ? 0 : docType[getIdentityType];              
    const watchIdentificationNumber = documentNumber;              
    const watchFullName = fullName;              
    const watchCellphoneNumber = phoneNumber;              
    const watchAddress =getAddress;              
    const watchEmail = watch('email');

    useEffect(() => {
      const fetchCreditRenovation = async () => {
        const body = {
          rol: 'getBankList',
        };
        const resul = await ConsultGeneral.postConsultPSE(body);
        const formattedBankList = resul.map(element => ({
          value: element.financialInstitutionCode,
          label: element.financialInstitutionName
        }));
        setFetchedConsultBankList(formattedBankList);
      };
      fetchCreditRenovation();
    }, []);

    const showDialog = (message) => {
      dialog.custom(
        <div className="space-y-4 text-center">
          {/* <Emoji symbol="warning" className="inline h-12" /> */}
          <p className=" ">{message}</p>
          <span className="font-bold m-5 text-2xl" >{formatCurrency(transactionValue)}</span>
          <p className="">A la referencia de pago:</p>
          <span className="font-bold m-5 text-2xl" >{ticketId}</span>
          <div className="flex w-full justify-center space-x-2">
            <Button
              onClick={async () => {
                dialog.close();
              }}
              customColor="bg-custom-red"
            >
              {'Cancelar'}
            </Button>
            <Button
              onClick={async () => {
                sendCreateTransactionPayment();
                close();
              }}
            >
              {'Ok'}
            </Button>
          </div>
        </div>,
        // <button onClick={() => dialog.close()}>
        //   <MdClose className="h-6 w-auto" />
        // </button>
      );
    };
    const showDialogProceso = (message, newTransaction) => {
      dialog.custom(
        <>
          <div className="space-y-4 text-center">
            <p>
          {message}

            </p>
          </div>
          <div className="flex w-full justify-center space-x-2 mt-5">
            <Button
              onClick={async () => {
                dialog.close();
              }}
              customColor="bg-custom-red"
            >
              {'Cerrar'}
            </Button>
            
            {newTransaction &&(<Button
              onClick={async () => {
                newTransactionSet = true;
                sendCreateTransactionPayment();
                close();
              }}
            >
              {'Sí'}
            </Button>)}
          </div>
        </>,
      );
    };
    const hasTwentyMinutesPassed = (dateString) => {
      const givenTime = moment(dateString);
      const currentTime = moment();
      return currentTime.diff(givenTime, 'minutes') >= 20;
    };  

    const sendCreateTransactionPayment = async () => {
      console.log(fetchedLastCredit);
      let erroForm = false;
      const bodyValidateTransaction = {
        creditId: watchCreditId,
        ticketId,
        active: 0,
        functions: 'getTransactionInformation',
        rol: 'consultHistorialTransactionPaymentPSEOk',
      };

      await ConsultGeneral.postConsultPSE(bodyValidateTransaction)
              .then(async (response) => {
                if ((response[0]?.transactionState === 'SUCCESS' || response[0]?.transactionState === 'OK') && !hasTwentyMinutesPassed(response[0]?.createtime) && !newTransactionSet) {
                  showDialogProceso(`Ya tienes una transacción aprobada el ${formatDateHour(response[0].createtime, { showHour: true, })} ¿Deseas realizar un nuevo pago?`, true);
                  return;
                }
                const body = {
                  creditId: watchCreditId,
          
                  financialInstitutionCode: Number(watchFinancialInstitutionCode) === 0 
                  ? (setGetError(true), erroForm = true, null)  // Devuelve null o un valor válido
                  : watchFinancialInstitutionCode,
          
                  transactionValue: watchTransactionValue === '' 
                  ? (setGetError(true), erroForm = true, null)  // Devuelve null o un valor válido
                  : watchTransactionValue,
          
                  ticketId: watchTicketId,
                  ticketIdPse: watchTicketIdPse,

                  userType: 'person',
                  referenceNumber1: watchReferenceNumber1 === ''
                  ? (setGetError(true), erroForm = true, null)  // Devuelve null o un valor válido
                  : watchReferenceNumber1,
          
                  referenceNumber2: watchReferenceNumber2 === ''
                  ? (setGetError(true), erroForm = true, null)  // Devuelve null o un valor válido
                  : watchReferenceNumber2,
          
                  referenceNumber3: watchReferenceNumber3 === ''
                  ? (setGetError(true), erroForm = true, null)  // Devuelve null o un valor válido
                  : watchReferenceNumber3,
          
                  paymentDescription: watchPaymentDescription,
          
                  identificationType: Number(watchIdentificationType) === 0 
                  ? (setGetError(true), erroForm = true, null) 
                  : watchIdentificationType,
          
                  identificationNumber: watchIdentificationNumber === ''
                  ? (setGetError(true), erroForm = true, null)  // Devuelve null o un valor válido
                  : watchIdentificationNumber,
          
                  fullName: watchFullName === ''
                  ? (setGetError(true), erroForm = true, null)  // Devuelve null o un valor válido
                  : watchFullName,
          
                  cellphoneNumber: watchCellphoneNumber === ''
                  ? (setGetError(true), erroForm = true, null)  // Devuelve null o un valor válido
                  : watchCellphoneNumber,
          
                  address: watchAddress,
                  email: watchEmail === ''
                  ? (setGetError(true), erroForm = true, null)  // Devuelve null o un valor válido
                  : watchEmail,
          
                  rol: 'createTransactionPayment',
                };
                if (erroForm) {
                  dialog.close();
                  return;
                } else {
                  setGetError(false);
                  erroForm = false;        
                }
            
                dialog.close();
                await ConsultGeneral.postConsultPSE(body)
                  .then(async (responseCreate) => {
                    const errorCodes = [
                      'FAIL_ENTITYNOTEXISTSORDISABLED',
                      'FAIL_BANKNOTEXISTSORDISABLED',
                      'FAIL_SERVICENOTEXISTSORNOTCONFIGURED',
                      'FAIL_INVALIDAMOUNTORVATAMOUNT',
                      'FAIL_INVALIDSOLICITDATE',
                      'FAIL_CANNOTGETCURRENTCYCLE',
                      'FAIL_ACCESSDENIED',
                      'FAIL_TRANSACTIONNOTALLOWED',
                      'FAIL_INVALIDPARAMETERS',
                      'FAIL_GENERICERROR',
                      'FAIL_DISABLEDUSEREMAIL'
                    ];
                    
                    if (errorCodes.includes(responseCreate?.returnCode)) {
                      setGetErrorfailed(true);
                      return;
                    }
                    const errorCodesLimit = [
                      'FAIL_EXCEEDEDLIMIT'
                    ];
                    
                    if (errorCodesLimit.includes(responseCreate?.returnCode)) {
                      setGetErrorfailedLimit(true);
                      return;
                    }
                    
                    if (responseCreate.returnCode === 'SUCCESS') {
                      window.location.href =responseCreate.pseURL;
                      // const body = {
                      //   creditId: watchCreditId,
                      //   trazabilityCode: responseCreate.trazabilityCode,
                      //   ticketId: watchTicketId,
                      //   rol: 'getTransactionInformation',
                      // };
                  
                      // await ConsultGeneral.postConsultPSE(body)
                      //   .then((response) => {
                      //     console.log(response);
                          
                      //     if (response.returnCode === 'SUCCESS') {
                      //     }
                      //   })
                      //   .catch((error) => {
                      //     console.error(error);
                      //   });
                      
                    } else if ( responseCreate.length > 0 && responseCreate[0].trazabilityCode) {
                      const body = {
                        creditId: watchCreditId,
                        trazabilityCode: responseCreate.trazabilityCode,
                        ticketId: watchTicketId,
                        rol: 'getTransactionInformation',
                      };
                  
                      await ConsultGeneral.postConsultPSE(body)
                        .then((getTransactionInformationResponse) => {
                          console.log(getTransactionInformationResponse);
                          
                          if (getTransactionInformationResponse.transactionState === 'PENDING' || hasTwentyMinutesPassed(getTransactionInformationResponse.createtime)) {
                            showDialogProceso('Tienes un pago en proceso');
                          // eslint-disable-next-line no-undef
                            const url = `${process.env.REACT_APP_ENTITYURL}?ticketId=${watchTicketId}&creditId=${watchCreditId}&functions=getTransactionInformation&trazabilityCode=${getTransactionInformationResponse.trazabilityCode}`;
                            navigate(url);
                          }
                        })
                        .catch((error) => {
                          console.error(error);
                        });
                      
          
                    }
                    // navigate('/confirmacion-pago');
                  })
                  .catch(async (error) => {
                    console.error(error);
                      showDialogProceso('Ya tienes un pago en proceso error');
          
                    dialog.info(DIALOG.N11, {
                      devInfo: error.message || error.code || error.type,
                    });
                  });
              })
              .catch((error) => {
                console.error(error);
              });
      

      
    };

    const fetchLastCredit = () =>
      CreditoService.getLast(user.sub)
        .then(async (response) => {
          await reset(
            {
              ...response,
              ...Cache.getItem('requestForm'),
              documento: user['custom:document'],
              terminosCondiciones: undefined,
              tratamientoDatos: undefined,
              centralesRiesgo: undefined,
            },
            { keepDefaultValues: true }
          );
          await setFetchedLastCredit(true);
        })
        .catch((error) => {
          console.error(error);
          dialog.info(DIALOG.N11, {
            devInfo: error.message || error.code || error.type,
          });
        });

    const fetchConstantes = () =>
      ConstantesSolicitudService.get()
        .then((response) => {
          setFormConstants(response);
          Cache.setItem('form-constants', response);
        })
        .catch((error) => {
          console.error(error);
          dialog.info(DIALOG.N11, {
            devInfo: error.message || error.code || error.type,
          });
        });

    const checkFinancialBlockade = async () => {
      const body = {
        nro_identificacion: user['custom:document'],
        rol: 'consultaOpenCreditosPantalla',
      };
      const resul = await OpenCoopCrmService.postOpenCoop(body);
      if (resul?.listCustomer?.length > 0) {
        
        resul?.listCustomer[0].forEach((item) => {
          if(item.id === Number(ticketId)) {
            setGetCreditId(item.codigo_unico);
            setGetAddress(item.direccion ? item.direccion : 'Address');
            setGetIdentityType(item.tipoidentificacion === 'C' || item.tipoidentificacion === 'TI' || item.tipoidentificacion === 'E' ? docTypeOpen[item.tipoidentificacion]: 1);
          }
        });
      }
    };

  useEffect(() => {
      const checkData = async () => {
      await checkFinancialBlockade();
      };
      checkData();
    }, []);
        
  
useEffect(() => {
    fetchLastCredit();
    if (!formConstants) fetchConstantes();
  }, []);
  useEffect(() => {
    if (getErrorfailed) {
      showDialogProceso(
        <p className="col-start-1">
          No se pudo crear la transacción, por favor intenta más tarde o comunícate con nuestro centro de relacionamiento en {' '}
          <a href="https://educacionestrella.com/contactanos/" target='_blank' rel="noreferrer">
            https://educacionestrella.com/contactanos/
          </a>
        </p>
      );
  
      // Resetear el error para que pueda volver a activarse
      setTimeout(() => {
        setGetErrorfailed(false);
      }, 500); // Ajusta el tiempo si es necesario
    }
  }, [getErrorfailed]);
  useEffect(() => {
    if (getErrorfailedLimit) {
      showDialogProceso(
        <p className="col-start-1">
            El monto de la transacción excede los límites establecidos en PSE para la empresa, comunícate con nuestro centro de relacionamiento en {' '}
          <a href="https://educacionestrella.com/contactanos/" target='_blank' rel="noreferrer">
            https://educacionestrella.com/contactanos/
          </a>
        </p>
      );
  
      // Resetear el error para que pueda volver a activarse
      setTimeout(() => {
        setGetErrorfailedLimit(false);
      }, 500); // Ajusta el tiempo si es necesario
    }
  }, [getErrorfailedLimit]);
  
  
  return (
    <>      <section>
        <h4 className="font-bold">Información del Pago</h4>
          <br />
        <div className="my-4 grid grid-cols-2 gap-4 gap-y-6 lg:my-6 lg:grid-cols-22 lg:gap-6">
          <div>
          
          <FormInput
              {...InputProps('financialInstitutionCode')}
              placeholder="Lista de bancos"
              type="select"
              options={fetchedConsultBankList}
              className="col-span-4 lg:col-span-5"
            />
          </div>

          <FormInput
            {...InputProps('referenceNumber1')}
            placeholder="Nombre Completo"
            type="textChangeWord"
            // readOnly={true}
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
          />
          
          <FormInput
            {...InputProps('referenceId')}
            placeholder="Referencia de pago"
            type="textChangeWord"
            readOnly={true}
            value={ticketId}
            
          />
            <Select
              name='identificationType'
              placeholder='Tipo documento'
              options={formConstants?.TIPO_DOCUMENTO}
              onChange={(value) => {
                setGetIdentityType(value);
              }}
              value={getIdentityType}
            />

          <FormInput
            {...InputProps('transactionValue')}
            placeholder="$ Valor a Pago"
            type="textChangeWord"
            value={transactionValue}
            onChange={(e) => setTransactionValue(e.target.value)}
          />
          
          <FormInput
            {...InputProps('referenceNumber2')}
            placeholder="No. Documento"
            type="textChangeWord"
            value={documentNumber}
            onChange={(e) => setDocumentNumber(e.target.value)}
            
          />
          <div>
          </div>

          <FormInput
            {...InputProps('referenceNumber3')}
            placeholder="Celular"
            type="textChangeWord"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            />
            <div></div>
          <FormInput
            {...InputProps('email')}
            placeholder="Correo"
            type="email"
            value= {user?.email}
          />
          <div></div>
          { getError && (
              <p className="text-[#E7496C]">
                * Completa todos los campos
              </p>
            )}

           
            
            <p className="col-start-1 text-[#E7496C]">
              Los pagos realizados se verán reflejados en el sistema, hasta en 2 días hábiles.
            </p>

        <div className="my-4 text-center">
          <Button
            onClick={() =>
              showDialog('Realizar pago de:', sendCreateTransactionPayment)
            }
          >
            Pagar
          </Button>
        </div>
        </div>
      </section>
    </>
  );
};

export default LandingPayuaCreate;
